import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { getAllCountries } from "helpers/utils/locationUtil";

import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import "./Subscription.scss";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import { charactersWithSpaces } from "helpers/validations/regex";

function AddSubscription() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [countries, setCountries] = useState([]);

  const [selectedDuration, setSelectedDuration] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packageAmount, setPackageAmount] = useState(0);

  const [finalValue, setFinalValue] = useState(0);

  const initialValues = {
    duration: 0, // Duration in months
    packageType: "", // Package type: "Advance", "Pro", etc.
    amount: 0,
    organizationName: "",
    country: "",
    vatNumber: "",
    pan: "",
    tan: "",
    email: "",
    password: "",
    confirmPassword: "",
    primaryContact: "",
  };
  const validation = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      packageType: Yup.string().required("Package Required"),
      organizationName: Yup.string()
        .required("Please enter organization name")
        .matches(
          charactersWithSpaces,
          "Organization Name should only contain characters"
        ),
      country: Yup.string()
        .required("Please select a country")
        .matches(
          charactersWithSpaces,
          "Country Name should only contain characters"
        ),
      vatNumber: Yup.string().required("Please enter VAT/registration number"),
      pan: Yup.string().required("Pan is required"),
      tan: Yup.string().required("TAN is Required"), // TAN is optional, so no requirement
      email: Yup.string()
        .email("Must be a valid email")
        .required("Please enter email"),
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password is too short - should be 8 characters minimum.")
        .matches(
          /^(?=.*[a-z])/,
          "Password must contain at least one lowercase letter."
        )
        .matches(
          /^(?=.*[A-Z])/,
          "Password must contain at least one uppercase letter."
        )
        .matches(/^(?=.*\d)/, "Password must contain at least one number.")
        .matches(
          /^(?=.*[!@#$%^&*()\-_=+{};:,<.>])/,
          "Password must contain at least one special character."
        ),
      amount: Yup.number()
        .required("Please enter the amount paid")
        .positive("Amount must be a positive number"),
      gstNumber: Yup.string().required("Please enter the GST Number"),
      primaryContact: Yup.string().required("Primary Contact is required"),
      mobile: Yup.string().required("Mobile Number is Required"),
    }),
    onSubmit: async (values) => {
      console.log(values);
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      const fetchedCountries = getAllCountries();
      setCountries(fetchedCountries);
      console.log(fetchedCountries);
      console.log(countries);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (selectedDuration) {
      console.log("Selected Duration:", selectedDuration);
    }
  }, [selectedDuration]);

  const handleRadioChange = (event) => {
    setSelectedDuration(parseInt(event.target.value));
  };

  useEffect(() => {
    switch (selectedPackage) {
      case "Basic":
        setPackageAmount(0);
        break;
      case "Advance":
        setPackageAmount(50);
        break;
      case "Pro":
        setPackageAmount(200);
        break;
      default:
        setPackageAmount(0);
    }
  }, [selectedPackage]);

  const handlePackageChange = (event) => {
    setSelectedPackage(event.target.value);
    validation.setFieldValue("packageType", event.target.value);
    console.log(packageAmount);
  };

  useEffect(() => {
    let finalvalue = selectedDuration * packageAmount;
    console.log(finalvalue);
    setFinalValue(finalvalue);
  }, [selectedDuration, packageAmount]);

  const heading = id ? "Update" : "Add";

  return (
    <>
      <div className="page-content">
        <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
          <PageSubHeader
            heading={`${heading} Subscription`}
            routePath={"Home"}
            pageName={`${heading} Subscription`}
          />
          <Row className="p-4">
            <Col>
              <Card>
                <CardBody>
                  <Form
                    className="row g-3 needs-validation py-4"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>
                      <Row>
                        <FormGroup>
                          <Label for="duration">
                            Subscription Duration{" "}
                            <span className="text-danger"> *</span>
                          </Label>
                          <Row style={{ marginLeft: "7em", marginTop: "2em" }}>
                            <Row>
                              <Col sm="3" className="mb-3">
                                <FormGroup check>
                                  <Label check style={{ fontWeight: "500" }}>
                                    <Input
                                      type="radio"
                                      name="duration"
                                      value={1}
                                      id="duration"
                                      onChange={handleRadioChange}
                                    />{" "}
                                    1 Month
                                  </Label>
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-3">
                                <FormGroup check>
                                  <Label check style={{ fontWeight: "500" }}>
                                    <Input
                                      type="radio"
                                      name="duration"
                                      value={3}
                                      id="duration"
                                      onChange={handleRadioChange}
                                    />{" "}
                                    3 Months
                                  </Label>
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-3">
                                <FormGroup check>
                                  <Label check style={{ fontWeight: "500" }}>
                                    <Input
                                      type="radio"
                                      name="duration"
                                      value={6}
                                      id="duration"
                                      onChange={handleRadioChange}
                                    />{" "}
                                    6 Months
                                  </Label>
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-3">
                                <FormGroup check>
                                  <Label check style={{ fontWeight: "500" }}>
                                    <Input
                                      type="radio"
                                      name="duration"
                                      value={12}
                                      id="duration"
                                      onChange={handleRadioChange}
                                    />{" "}
                                    12 Months
                                  </Label>
                                </FormGroup>
                              </Col>
                            </Row>
                          </Row>
                        </FormGroup>
                      </Row>
                      <Row className="py-3">
                        <FormGroup className="mb-3">
                          <Label>
                            Package Type<span className="text-danger">*</span>
                          </Label>
                          <div className="subscription-grid">
                            <label className="subscription-card">
                              <Input
                                name="packageType"
                                className="subscription-radio"
                                type="radio"
                                value="Basic"
                                onChange={handlePackageChange}
                                checked={
                                  validation.values.packageType === "Basic"
                                }
                              />
                              <span className="subscription-plan-details">
                                <span className="subscription-plan-type">
                                  Basic
                                </span>
                                <span className="subscription-plan-cost">
                                  $0
                                  <span className="subscription-slash">/</span>
                                  <span className="subscription-plan-cycle">
                                    mo
                                  </span>
                                </span>
                                <span>1 team member</span>
                                <span>100 GB/mo</span>
                                <span>1 concurrent build</span>
                              </span>
                            </label>

                            <label className="subscription-card">
                              <Input
                                name="packageType"
                                className="subscription-radio"
                                type="radio"
                                value="Advance"
                                onChange={handlePackageChange}
                                checked={
                                  validation.values.packageType === "Advance"
                                }
                              />
                              {/* <span className="subscription-hidden-visually">
                                Premium - $50 per month, 5 team members, 500 GB per
                                month, 5 concurrent builds
                              </span> */}
                              <span
                                className="subscription-plan-details"
                                aria-hidden="true"
                              >
                                <span className="subscription-plan-type">
                                  Advance
                                </span>
                                <span className="subscription-plan-cost">
                                  $50
                                  <span className="subscription-slash">/</span>
                                  <span className="subscription-plan-cycle">
                                    mo
                                  </span>
                                </span>
                                <span>5 team members</span>
                                <span>500 GB/mo</span>
                                <span>5 concurrent builds</span>
                              </span>
                            </label>

                            <label className="subscription-card">
                              <Input
                                name="packageType"
                                className="subscription-radio"
                                type="radio"
                                value="Pro"
                                onChange={handlePackageChange}
                                checked={
                                  validation.values.packageType === "Pro"
                                }
                              />
                              {/* <span className="subscription-hidden-visually">
                                Enterprise - $200 per month, 5+ team members, 1000
                                GB per month, Unlimited builds
                              </span> */}
                              <span
                                className="subscription-plan-details"
                                aria-hidden="true"
                              >
                                <span className="subscription-plan-type">
                                  Pro
                                </span>
                                <span className="subscription-plan-cost">
                                  $200
                                  <span className="subscription-slash">/</span>
                                  <span className="subscription-plan-cycle">
                                    mo
                                  </span>
                                </span>
                                <span>5+ team members</span>
                                <span>1000 GB/mo</span>
                                <span>Unlimited builds</span>
                              </span>
                            </label>
                          </div>
                        </FormGroup>
                      </Row>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Organization Name
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="organizationName"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.organizationName || ""}
                            invalid={
                              validation.touched.organizationName &&
                              validation.errors.organizationName
                                ? true
                                : false
                            }
                          />
                          {validation.touched.organizationName &&
                          validation.errors.organizationName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.organizationName}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Country<span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="country"
                            type="select"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.country || ""}
                            invalid={
                              validation.touched.country &&
                              validation.errors.country
                                ? true
                                : false
                            }
                          >
                            <option value="Select">Select</option>
                            {countries.map((country) => (
                              <option key={country.value} value={country.value}>
                                {country.label}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.country &&
                          validation.errors.country ? (
                            <FormFeedback type="invalid">
                              {validation.errors.country}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            VAT/Registration Number
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="vatNumber"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.vatNumber || ""}
                            invalid={
                              validation.touched.vatNumber &&
                              validation.errors.vatNumber
                                ? true
                                : false
                            }
                          />
                          {validation.touched.vatNumber &&
                          validation.errors.vatNumber ? (
                            <FormFeedback type="invalid">
                              {validation.errors.vatNumber}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            GST Number
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="gstNumber"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.gstNumber || ""}
                            invalid={
                              validation.touched.gstNumber &&
                              validation.errors.gstNumber
                                ? true
                                : false
                            }
                          />
                          {validation.touched.gstNumber &&
                          validation.errors.gstNumber ? (
                            <FormFeedback type="invalid">
                              {validation.errors.gstNumber}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>PAN</Label>
                          <Input
                            name="pan"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.pan || ""}
                            invalid={
                              validation.touched.pan && validation.errors.pan
                                ? true
                                : false
                            }
                          />
                          {validation.touched.pan && validation.errors.pan ? (
                            <FormFeedback type="invalid">
                              {validation.errors.pan}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>TAN</Label>
                          <Input
                            name="tan"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.tan || ""}
                            invalid={
                              validation.touched.tan && validation.errors.tan
                                ? true
                                : false
                            }
                          />
                          {validation.touched.tan && validation.errors.tan ? (
                            <FormFeedback type="invalid">
                              {validation.errors.tan}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Email<span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="email"
                            type="email"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Amount
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="amount"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={finalValue}
                            invalid={
                              validation.touched.amount &&
                              validation.errors.amount
                                ? true
                                : false
                            }
                            disabled
                          />
                          {validation.touched.amount &&
                          validation.errors.amount ? (
                            <FormFeedback type="invalid">
                              {validation.errors.amount}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Primary Contact
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="primaryContact"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.primaryContact || ""}
                            invalid={
                              validation.touched.primaryContact &&
                              validation.errors.primaryContact
                                ? true
                                : false
                            }
                          />
                          {validation.touched.primaryContact &&
                          validation.errors.primaryContact ? (
                            <FormFeedback type="invalid">
                              {validation.errors.primaryContact}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Mobile
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="mobile"
                            type="tel"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.mobile || ""}
                            invalid={
                              validation.touched.mobile &&
                              validation.errors.mobile
                                ? true
                                : false
                            }
                          />
                          {validation.touched.mobile &&
                          validation.errors.mobile ? (
                            <FormFeedback type="invalid">
                              {validation.errors.mobile}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Password
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="password"
                            type="password"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Confirm Password
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="confirmPassword"
                            type="password"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.confirmPassword || ""}
                            invalid={
                              validation.touched.confirmPassword &&
                              validation.errors.confirmPassword
                                ? true
                                : false
                            }
                          />
                          {validation.touched.confirmPassword &&
                          validation.errors.confirmPassword ? (
                            <FormFeedback type="invalid">
                              {validation.errors.confirmPassword}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                  <Row>
                    <Col xs={12} className="card-header">
                      <p className="form-header">
                        Subscription Plan Information
                      </p>
                    </Col>

                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Plan Amount
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="planAmount"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.planAmount || ""}
                          invalid={
                            validation.touched.planAmount &&
                            validation.errors.planAmount
                              ? true
                              : false
                          }
                        />
                        {validation.touched.planAmount &&
                        validation.errors.planAmount ? (
                          <FormFeedback type="invalid">
                            {validation.errors.planAmount}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          CGST (Central GST)
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="cgst"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.cgst || ""}
                          invalid={
                            validation.touched.cgst && validation.errors.cgst
                              ? true
                              : false
                          }
                        />
                        {validation.touched.cgst && validation.errors.cgst ? (
                          <FormFeedback type="invalid">
                            {validation.errors.cgst}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          SGST (State GST)
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="sgst"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.sgst || ""}
                          invalid={
                            validation.touched.sgst && validation.errors.sgst
                              ? true
                              : false
                          }
                        />
                        {validation.touched.sgst && validation.errors.sgst ? (
                          <FormFeedback type="invalid">
                            {validation.errors.sgst}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Total Tax
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="totalTax"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.totalTax || ""}
                          invalid={
                            validation.touched.totalTax &&
                            validation.errors.totalTax
                              ? true
                              : false
                          }
                        />
                        {validation.touched.totalTax &&
                        validation.errors.totalTax ? (
                          <FormFeedback type="invalid">
                            {validation.errors.totalTax}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Total Amount
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="totalAmount"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.totalAmount || ""}
                          invalid={
                            validation.touched.totalAmount &&
                            validation.errors.totalAmount
                              ? true
                              : false
                          }
                        />
                        {validation.touched.totalAmount &&
                        validation.errors.totalAmount ? (
                          <FormFeedback type="invalid">
                            {validation.errors.totalAmount}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className="card-header">
                      <p className="form-header">Subscription Dates</p>
                    </Col>

                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Trial Period
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="trialPeriod"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.trialPeriod || ""}
                          invalid={
                            validation.touched.trialPeriod &&
                            validation.errors.trialPeriod
                              ? true
                              : false
                          }
                        />
                        {validation.touched.trialPeriod &&
                        validation.errors.trialPeriod ? (
                          <FormFeedback type="invalid">
                            {validation.errors.trialPeriod}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Date Registered
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="dateRegistered"
                          type="date"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.dateRegistered || ""}
                          invalid={
                            validation.touched.dateRegistered &&
                            validation.errors.dateRegistered
                              ? true
                              : false
                          }
                        />
                        {validation.touched.dateRegistered &&
                        validation.errors.dateRegistered ? (
                          <FormFeedback type="invalid">
                            {validation.errors.dateRegistered}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Start Date
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="startDate"
                          type="date"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.startDate || ""}
                          invalid={
                            validation.touched.startDate &&
                            validation.errors.startDate
                              ? true
                              : false
                          }
                        />
                        {validation.touched.startDate &&
                        validation.errors.startDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.startDate}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Duration (in Months)
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="duration"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.duration || ""}
                          invalid={
                            validation.touched.duration &&
                            validation.errors.duration
                              ? true
                              : false
                          }
                        />
                        {validation.touched.duration &&
                        validation.errors.duration ? (
                          <FormFeedback type="invalid">
                            {validation.errors.duration}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Expiry Date
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="expiryDate"
                          type="date"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.expiryDate || ""}
                          invalid={
                            validation.touched.expiryDate &&
                            validation.errors.expiryDate
                              ? true
                              : false
                          }
                        />
                        {validation.touched.expiryDate &&
                        validation.errors.expiryDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.expiryDate}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className="card-header">
                      <p className="form-header">
                        Renewal and Payment Information
                      </p>
                    </Col>
                    {/* Auto Renewal: Checkbox */}
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>Auto Renewal</Label>
                        <div className="form-check">
                          <Input
                            name="autoRenewal"
                            type="checkbox"
                            className="form-check-input"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            checked={validation.values.autoRenewal || false}
                            invalid={
                              validation.touched.autoRenewal &&
                              validation.errors.autoRenewal
                                ? true
                                : false
                            }
                            style={{
                              width: "20px",
                              height: "20px",
                              borderWidth: "1px",
                              borderColor: "#000",
                              cursor: "pointer",
                            }}
                          />
                          {validation.touched.autoRenewal &&
                          validation.errors.autoRenewal ? (
                            <FormFeedback type="invalid">
                              {validation.errors.autoRenewal}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </FormGroup>
                    </Col>

                    {/* Payment Mode: Dropdown */}
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Payment Mode
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="paymentMode"
                          type="select"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.paymentMode || ""}
                          invalid={
                            validation.touched.paymentMode &&
                            validation.errors.paymentMode
                              ? true
                              : false
                          }
                        >
                          <option value="">Select Payment Mode</option>
                          <option value="Credit Card">Credit Card</option>
                          <option value="Bank Transfer">Bank Transfer</option>
                          <option value="PayPal">PayPal</option>
                          <option value="Other">Other</option>
                        </Input>
                        {validation.touched.paymentMode &&
                        validation.errors.paymentMode ? (
                          <FormFeedback type="invalid">
                            {validation.errors.paymentMode}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    {/* Invoice Delivered: Checkbox */}
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>Invoice Delivered</Label>
                        <div className="form-check">
                          <Input
                            name="invoiceDelivered"
                            type="checkbox"
                            className="form-check-input"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            // checked={
                            //   validation.values.invoiceDelivered || false
                            // }
                            invalid={
                              validation.touched.invoiceDelivered &&
                              validation.errors.invoiceDelivered
                                ? true
                                : false
                            }
                            style={{
                              width: "20px",
                              height: "20px",
                              borderWidth: "1px",
                              borderColor: "#000",
                              cursor: "pointer",
                            }}
                          />
                          {validation.touched.invoiceDelivered &&
                          validation.errors.invoiceDelivered ? (
                            <FormFeedback type="invalid">
                              {validation.errors.invoiceDelivered}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </FormGroup>
                    </Col>

                    {/* Invoice Number: Text Field */}
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Invoice #<span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="invoiceNumber"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.invoiceNumber || ""}
                          invalid={
                            validation.touched.invoiceNumber &&
                            validation.errors.invoiceNumber
                              ? true
                              : false
                          }
                        />
                        {validation.touched.invoiceNumber &&
                        validation.errors.invoiceNumber ? (
                          <FormFeedback type="invalid">
                            {validation.errors.invoiceNumber}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    {/* Invoice Date: Date Picker */}
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Invoice Date
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="invoiceDate"
                          type="date"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.invoiceDate || ""}
                          invalid={
                            validation.touched.invoiceDate &&
                            validation.errors.invoiceDate
                              ? true
                              : false
                          }
                        />
                        {validation.touched.invoiceDate &&
                        validation.errors.invoiceDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.invoiceDate}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    {/* Transaction Number: Text Field */}
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label>
                          Transaction Number
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="transactionNumber"
                          type="text"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.transactionNumber || ""}
                          invalid={
                            validation.touched.transactionNumber &&
                            validation.errors.transactionNumber
                              ? true
                              : false
                          }
                        />
                        {validation.touched.transactionNumber &&
                        validation.errors.transactionNumber ? (
                          <FormFeedback type="invalid">
                            {validation.errors.transactionNumber}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer save={validation.handleSubmit} />
    </>
  );
}

export default AddSubscription;
